import { Component, Event, EventEmitter, Prop, h, State } from '@stencil/core';
import { ApiCall } from '../../../helpers/ApiCall';

import icoDown from '../../../assets/ico-down.svg';

@Component({
    tag: 'agreement-view',
    shadow: false,
})
export class AgreementView {
    @Prop() agreementType: string;
    @State() htmlContent: string;
    @State() atBottom: boolean = false;
    @State() scrollingToBottom: boolean = false;
    @State() scrollClass: string = 'scroll';

    scrollContainer: HTMLElement;

    @Event({
        eventName: 'apiError',
    })
    apiErrorEvent: EventEmitter<any>;

    @Event({
        eventName: 'atBottom',
    })
    atBottomEvent: EventEmitter<any>;

    async componentDidLoad() {
        try {
            this.htmlContent = await ApiCall.instance.GetAgreement(this.agreementType);
        } catch (e) {
            this.apiErrorEvent.emit(e);
        }
    }

    handleScroll = (e: Event) => {
        if (this.scrollingToBottom) {
            return;
        }
    
        const target = e.target as HTMLElement;
        const threshold = 5;
        this.atBottom = target.scrollHeight - target.scrollTop - target.clientHeight < threshold;

        if (this.atBottom)
            this.atBottomEvent.emit(true);
    };

    scrollToBottom = () => {
        this.scrollingToBottom = true;
        this.atBottom = true;
        this.atBottomEvent.emit(true);

        if (this.scrollContainer) {
            this.scrollContainer.scrollTo({
                top: this.scrollContainer.scrollHeight,
                behavior: 'smooth',
            });
        }

        setTimeout(() => {
            this.scrollingToBottom = false;
        }, 200);
    };

    render() {
        return (
            <div class="document-view">
                <div ref={el => (this.scrollContainer = el)} class={this.scrollClass} style={{height:'calc(100% - 60px)'}} onScroll={this.handleScroll} innerHTML={this.htmlContent}></div>
                <div class="flex center text-center" onClick={this.scrollToBottom} style={{height:'60px'}}>
                    <img src={icoDown}></img>
                </div>
            </div>
        );
    }
}